import initDonation from './donation';
import initFilterButtons from './filter_buttons';
import { initHeader, initAnchorNav } from './header';
import initPageList from './pages_list';
import initProductItem from './product_item';
import initShowList from './show_list';
import initThemeStickyHeader from './theme_sticky_header';
import initVideo from './video';
import { shortcutsMenu } from './shortcuts_menu';


function initParts(): void {
    initDonation();
    initFilterButtons();
    initHeader();
    initAnchorNav();
    initPageList();
    initProductItem();
    initShowList();
    initThemeStickyHeader();
    initVideo();
    shortcutsMenu.init();
}

export default initParts;
